t = require('views/internal/teacup-with-helpers')('organization_search_list_item')

module.exports = ->
  t.li ->
    t.a '.link-item', { href: '/' + t.mustacheVar('name') }, ->
      t.span '.item-name', ->
        t.text t.mustacheVar('displayName')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/organization_search_list_item.coffee